export const NAME = 'lisa-files';

export const STAGES = ['Loading', 'Reading', 'Analyzing', 'Finishing'];
